import React, { Fragment } from "react";
import _ from "lodash";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import { Icon } from "../../../components/icon/Icon";
import { RoamingDeviceProtectionStatus } from "../spson.types";
import { Mobile, NotMobile } from "../../../hocs/Responsive";
import { Tooltip } from "../../../components/tooltip/Tooltip";

import "./ProtectionStatus.scss";

interface Props {
  status?: RoamingDeviceProtectionStatus;
  showTooltip?: boolean;
}

const defaultInfo = {
  colorScheme: "disabled",
  icon: "fa-times-circle",
  message: "device_not_protected_info",
};

export const ProtectionStatus = ({ status, showTooltip }: Props) => {
  const protectionStatus = status || "unknown";
  const statusInfo = _.get(
    {
      [RoamingDeviceProtectionStatus.Disabled]: defaultInfo,
      [RoamingDeviceProtectionStatus.Enabled]: {
        colorScheme: "enabled",
        icon: "fa-check-circle",
        message: "device_protected_info",
      },
      unknown: {
        colorScheme: "unknown",
        icon: "fa-question-circle",
        message: "status_unknown_info",
      },
    },
    protectionStatus,
    defaultInfo
  );

  const content = <Icon role="img" icon={`fa-solid ${statusInfo.icon}`} />;

  return (
    <span
      className={classnames(
        "protection-status",
        `protection-status--${statusInfo.colorScheme}`
      )}
      data-testid={"protection-status"}
    >
      <Mobile>{content}</Mobile>
      <NotMobile>
        {showTooltip ? (
          <Tooltip
            content={<FormattedMessage id={statusInfo.message} />}
            theme="dark"
            role={"tooltip"}
          >
            {content}
          </Tooltip>
        ) : (
          <Fragment>
            {content}
            <span className="protection-status__value">
              <FormattedMessage id={statusInfo.message} />
            </span>
          </Fragment>
        )}
      </NotMobile>
    </span>
  );
};
